import "twin.macro";

import { useWatch } from "react-hook-form";

import { Alert } from "@mui/material";

import type { FormData } from "./DistributorForm";

const DistributorCheckoutOptionsWarning = () => {
  const distributorOrgs: FormData["distributorOrganizations"] = useWatch({
    name: "distributorOrganizations",
  });

  const orderers: FormData["orderers"] = useWatch({ name: "orderers" });

  const distOrgsMissingCheckoutOptions = Object.values(
    distributorOrgs ?? {}
  ).filter(
    (org) =>
      !org.allowBudgetCheckout &&
      !org.allowStripeCheckout &&
      !org.allowStandardCheckout
  );

  if (
    Object.values(orderers).length === 0 ||
    distOrgsMissingCheckoutOptions.length === 0
  )
    return null;

  return (
    <Alert severity="info">
      <ul tw="list-disc list-inside text-base">
        {distOrgsMissingCheckoutOptions.map((org) => (
          <li key={org.name}>
            Missing at least one allowed checkout method for {org.name}
          </li>
        ))}
      </ul>
    </Alert>
  );
};

export default DistributorCheckoutOptionsWarning;
